export enum PracticeArea {
  Corporate = 'corporate',
  Criminal = 'criminal',
  Disputes = 'disputes',
  Employment = 'employment',
  Family = 'family',
  Finance = 'finance',
  IntellectualProperty = 'intellectual-property',
  RealEstate = 'real-estate',
  Regulatory = 'regulatory',
  Tax = 'tax',
  Other = 'other',
}

export const PRACTICE_AREA_LABELS: Record<PracticeArea, string> = {
  [PracticeArea.Corporate]: 'Corporate',
  [PracticeArea.Criminal]: 'Criminal',
  [PracticeArea.Disputes]: 'Disputes',
  [PracticeArea.Employment]: 'Employment',
  [PracticeArea.Family]: 'Family',
  [PracticeArea.Finance]: 'Finance',
  [PracticeArea.IntellectualProperty]: 'Intellectual property',
  [PracticeArea.RealEstate]: 'Real estate',
  [PracticeArea.Regulatory]: 'Regulatory',
  [PracticeArea.Tax]: 'Tax',
  [PracticeArea.Other]: 'Other',
};
